// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"509":"f24dbb25","2520":"bcf542a4","4806":"ae2d105c"}[chunkId] + ".chunk.css";
};